import { ActivityIndicator, Linking, Platform } from 'react-native'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '../../navigationApp/types'
import { ThemedPressable, ThemedView } from '../../theme'
import BackButton from '../../sharedComponents/BackButton/BackButton'
import Typography from '../../sharedComponents/typography/Typography'
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema'
import LinkOutIcon from '../../../assets/Icons/LinkOutIcon'
import useSingleRemoteConfig from '../../hooks/useSingleRemoteConfig'
import ScreenWrapper from '@app/hoc/ScreenWrapper'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'LENDING_PARTNERS'>


const handleURLClick = (url: string) => {
    if (Platform.OS === 'web') {
        window.open(url)
    }
    else {
        Linking.openURL(url)
    }
}


const LendingPartners = ({ navigation , route }: ScreenProps) => {


    const { configValue, loading } = useSingleRemoteConfig('lending_partners_list');

    const lendingParnersData: {
        id: number,
        url: string,
        label: string
    }[] = configValue ? JSON.parse(configValue) : []


    if (loading) {
        return <ThemedView bg='bg-surface-primary' flex={1} justifyContent='center' alignItems='center'>
      <ActivityIndicator color={'#1434CB'} size={12} />
        </ThemedView>
    }

    return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
        <ThemedView bg='bg-surface-primary' flex={1}>
            <ThemedView borderBottomWidth={1} borderBottomColor='border-secondary' p='lg' flexDirection='row' alignItems='center'>
                <ThemedView mr='md'>
                    <BackButton navigation={navigation} />
                </ThemedView>
                <Typography label='Lending partners' color={ColorTokens.Grey_Night} />
            </ThemedView>

            <ThemedView paddingHorizontal='lg' mt='sm'>
                {lendingParnersData.map((item) => (
                    <ThemedPressable key={item?.id} onPress={() => {
                        handleURLClick(item?.url)
                    }} justifyContent='space-between' paddingVertical='lg' alignItems='center' flexDirection='row' borderBottomWidth={1} borderColor='border-secondary'>
                        <Typography
                            label={item?.label}
                            typeDLS={TypographyTypeDLS.B1R}
                            color={ColorTokens.Grey_Night}
                        />
                        <LinkOutIcon size={20} />
                    </ThemedPressable>
                ))}
            </ThemedView>
        </ThemedView>
        </ScreenWrapper>
    )
}

export default LendingPartners
